import { Upload, UploadProps } from "antd";
import { CreateNotification } from "../../../../../../../components/notifier";


const BASE_URL_UPLOAD = "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file-img";

interface Props extends UploadProps {
  maxSizePerFile?: number | false;
  maxSizeTotalFiles?: number | false;
}

const DEFAULT_MAX_SIZE_PER_FILE = 10485760; // 10MB

export const UploadVPCT = ({
  children,
  maxSizePerFile = DEFAULT_MAX_SIZE_PER_FILE,
  maxSizeTotalFiles = false,
  ...restProps
}: Props) => {
  return (
    <Upload
      {...restProps}
      action={BASE_URL_UPLOAD}
      beforeUpload={(file, fileList) => {
        const fileListSize = fileList.reduce((acc, cur) => acc + cur.size, 0);
        const fileListSizeExceeded = typeof maxSizeTotalFiles === "number" && fileListSize > maxSizeTotalFiles;
        const fileSizeExceeded = typeof maxSizePerFile === "number" && file.size > maxSizePerFile;

        if (fileSizeExceeded) {
          CreateNotification({
            title: "Thông báo",
            body: `Tệp ${file.name} quá lớn!`,
            icon: "/icons/warning.png",
          });
          return Upload.LIST_IGNORE;
        }
        if (fileListSizeExceeded) {
          CreateNotification({
            title: "Thông báo",
            body: `Tổng dung lượng tệp quá lớn!`,
            icon: "/icons/warning.png",
          });
          return Upload.LIST_IGNORE;
        }
      }}    
    >
      {children}
    </Upload>
  );
};
